// Notification / helper text. Per Figma (648-14063 / 2297-10297) this is a clean
// CENTERED line: gray body with the key part (email) in bold — no box, no icon.
export default function InfoPanel({ message, boldText, show, className = '' }) {
  if (!show) return null;

  let content = message;
  if (boldText && typeof message === 'string' && message.includes(boldText)) {
    const idx = message.indexOf(boldText);
    content = (
      <>
        {message.slice(0, idx)}
        <strong className="send-code-strong">{boldText}</strong>
        {message.slice(idx + boldText.length)}
      </>
    );
  }

  return (
    <div className={`send-code-info show ${className}`}>
      <p className="send-code-msg m-0">{content}</p>
    </div>
  );
}
